import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const BusinessSectionTopTitle = ({ title, topText, topGreen, isH1 }) => {
  const titleClasses = classNames({
    'lh-title fw5 f3 f2-m f1-l tc relative center mt0 mb1 dib': true,
    'mt3': topText
  })

  if (!title) return null

  const aboveTitle = topText && (
    <span
      className={`absolute top-0 left-0 f11 mt--3 o-80 ${
        topGreen ? 'green' : ''
      }`}
    >
      {topText}
    </span>
  )

  if (isH1) {
    return (
      <h1 className={titleClasses}>
        {aboveTitle}
        {title}
      </h1>
    )
  }

  return (
    <div className="tc">
      <h2 className={titleClasses}>
        {aboveTitle}
        {title}
      </h2>
    </div>
  )
}
BusinessSectionTopTitle.propTypes = {
  topGreen: PropTypes.bool,
  isH1: PropTypes.bool,
  title: PropTypes.string
}

export default BusinessSectionTopTitle



// WEBPACK FOOTER //
// ./src/components/business-section/business-section-top/business-section-top-title.js